import { observable, action } from 'mobx'

class Store {
  @observable currentStep = 0

  @observable merchantData = {}
  @action
  getMerchantData = data => {
    this.merchantData = data || {}
  }
}
export default Store
